import { useCallback, useEffect, useState } from 'react';
import EntityCombobox from '@/components/EntityCombobox';
import OrgFormDialog from '@/components/entities/OrgFormDialog';
import api from '@/lib/api';

/**
 * Searchable picker for an Organization, with an inline "New organization" action.
 * Self-fetches and manages its own list.
 */
const OrgPicker = ({ value, onChange, placeholder = 'Select an organization…', testId = 'org-picker' }) => {
  const [orgs, setOrgs] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [initialName, setInitialName] = useState('');

  const fetchOrgs = useCallback(async () => {
    try {
      const res = await api.get('/organizations');
      setOrgs(res.data);
    } catch { /* non-fatal */ }
  }, []);

  useEffect(() => { fetchOrgs(); }, [fetchOrgs]);

  const items = orgs.map((o) => ({ value: o.id, label: o.name, sublabel: `${(o.contacts || []).length} contact(s)` }));

  const handleSaved = (org) => {
    setOrgs((prev) => [org, ...prev.filter((o) => o.id !== org.id)]);
    onChange(org.id);
  };

  return (
    <>
      <EntityCombobox
        items={items}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        searchPlaceholder="Search organizations…"
        emptyText="No organizations found."
        createLabel="New organization"
        onCreate={(name) => { setInitialName(name || ''); setShowCreate(true); }}
        testId={testId}
      />
      <OrgFormDialog open={showCreate} onOpenChange={setShowCreate} onSaved={handleSaved} initialName={initialName} />
    </>
  );
};

export default OrgPicker;
